export default "__VITE_ASSET__xvmHNp4o__"